import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseIconButton, LinkIconButton } from './BaseIconButton';

const secondaryIconButtonStyle = {
    background: colorSystem.neutral.white,
    color: colorSystem.neutral[7],
    border: `1px solid ${colorSystem.neutral[3]}`,
    borderRadius: '4px',

    '&:hover': {
        background: colorSystem.primary[1],
        color: colorSystem.primary[6],
        border: `1px solid ${colorSystem.primary[3]}`,
    },
    '&:active': {
        background: colorSystem.primary[2],
        color: colorSystem.primary[7],
        border: `1px solid ${colorSystem.primary[3]}`,
    },
    '&:disabled': {
        background: colorSystem.neutral.white,
        color: colorSystem.neutral[5],
        border: `1px solid ${colorSystem.neutral[4]}`,
    },
};

const SecondaryIconButtonHost = styled(BaseIconButton)(secondaryIconButtonStyle);
const SecondaryIconButtonLinkHost = styled(LinkIconButton)(secondaryIconButtonStyle);

export const SecondaryIconButton = linkable(SecondaryIconButtonHost, { linkHost: SecondaryIconButtonLinkHost });
